import type { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'

import { env } from '~/env'
import {
  registerV3Interceptors,
  setBackendConfig,
} from '~/generated/backendProvider'
import { createCustomError } from '~/utils/error'

interface SentryError extends Error {
  response: {
    status: number
    headers: {
      'x-request-id': string
    }
    statusText: string
  }
  config: {
    url: string
  }
}

const isSentryError = (error: unknown): error is SentryError => {
  return (error as SentryError)?.response?.status > 400
}

const handleSentryError = (error: unknown) => {
  if (isSentryError(error)) {
    Sentry.captureException(
      createCustomError(
        'API Handling',
        `🚨 URL: ${error.config.url} Status: ${error.response.status}`,
        error,
      ),
      {
        tags: {
          request_id: error.response.headers['x-request-id'],
          backend_api_failing: error.config.url,
          label: 'backend_api_error',
          status: error.response.status,
          statusText: error.response.statusText,
        },
      },
    )
  }
}

registerV3Interceptors({
  onRequest: (config) => {
    config.headers = config.headers ?? {}
    return config
  },
  onResponse: (response) => {
    return response
  },
  errorHandler: (error: AxiosError) => {
    handleSentryError(error)
    throw error
  },
})

setBackendConfig({
  baseUrl: env.NEXT_PUBLIC_V3_API_URL,
  headers: {
    'x-request-id': crypto.randomUUID(),
    'x-project-id':
      typeof window !== 'undefined'
        ? (localStorage.getItem('current.project') ?? '')
        : '',
  },
})
